import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import {
  AcademicRefereeConfirmation,
  RefereeTickMode,
} from '../../../../Assessment';
import { HelperText } from '../../../../Application/components';
import { POLISH_MODULE_TEXT } from '../../lang';

export const PolishRefereeReportSelection = ({
  refetch,
}: {
  refetch: () => void;
}): React.ReactNode => {
  return (
    <div className="mt-4">
      <div className="w-full py-2 flex items-center bg-[#E1C0C0] rounded-[3px] font-semibold text-base">
        <HelperText className="flex items-center gap-2">
          <ErrorIcon sx={{ color: '#951d1d' }} />
          {POLISH_MODULE_TEXT.REFEREE_NOTE}
        </HelperText>
      </div>
      <AcademicRefereeConfirmation
        refereeTickMode={RefereeTickMode.DirectorPolish}
        refetchAssessment={refetch}
      />
    </div>
  );
};
